import React from 'react';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from './ExpansionPanel';
import { makeExpansionPanelShippingCostStyles } from 'styles/components/expansionPanel';
import logoGLS from 'assets/images/gls_logo.jpg';

type Props = {
    id: number;
    expandedPanelId: number | null;
    handleChange: Function;
};

const listItems = [
    'Koszt przesyłki kurierskiej wynosi 0 zł.',
    'Jeśli kupujesz wyłącznie multimedia, również nie płacisz za przesyłkę.',
    'Sposób płatności wybierasz przy składaniu zamówienia.',
];

const ShippingCost: React.FC<Props> = ({ id, expandedPanelId, handleChange }) => {
    const {
        list,
        listItem,
        logo,
        table,
        tableData,
        tableRow,
    } = makeExpansionPanelShippingCostStyles();

    return (
        <ExpansionPanel
            id={id}
            expandedPanelId={expandedPanelId}
            handleChange={handleChange}
            header="Koszty przesyłki"
        >
            <Grid container spacing={4}>
                <Grid item xs={12} sm={8} md={6}>
                    <table className={table}>
                        <tbody>
                            <tr className={tableRow}>
                                <td className={tableData}>
                                    przesyłka kurierska{' '}
                                    <img alt="GLS" className={logo} src={logoGLS} />
                                </td>
                                <td className={tableData}>
                                    <b>0 zł</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
                <Grid item xs={12} sm={8} md={6}>
                    <ul className={list}>
                        {listItems.map((item, index) => (
                            <li
                                key={index}
                                className={listItem}
                                dangerouslySetInnerHTML={{ __html: item }}
                            />
                        ))}
                    </ul>
                </Grid>
            </Grid>
        </ExpansionPanel>
    );
};

export default ShippingCost;
